<template>
  <div class="good-simple" >
    <slot name="img"></slot>
    <slot name="title"></slot>
    <slot name="info"></slot>
    <!-- <img src="http://baoyitech.oss-cn-hangzhou.aliyuncs.com/15688595037862be3231268ac39deaa3fc18ccaedc7ba" alt="纸否抽纸">
    <p>我是礼品商城</p> -->
  </div>
</template>
<script>
export default {
  name: 'good'
}
</script>
<style lang="scss" scoped>
  .good-simple{
    img{height: 243px;margin-bottom: 7px;align-self: center;}
    .good-title{font-size: 14px;line-height: 16px;
    color: rgba(0,0,0,.65);
    font-weight: 400;
    height: 32px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    margin-bottom: 8px;
    box-sizing: border-box;
    letter-spacing: .7px;
    -webkit-box-orient: vertical;
    }
    .new-img{height: 227px;margin-bottom: 2px;}
    .news-title{font-size: 14px;
    line-height: 20px;
    color: rgba(0,0,0,.55);
    font-weight: 400;
    letter-spacing: .7px;
    margin-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    height: 40px;
    -webkit-box-orient: vertical;
    }
    div{padding: 7px 0 2px;display: flex;line-height: 23px;color: #f64f6f;padding: 3px;align-items: flex-end;
    span{font-size: 22px;padding: 0px 3px;line-height: 25px;color:rgb(246, 79, 111);font-weight: 400;letter-spacing: 3px;margin-right: 5px;}
    }
  }
</style>